import { setupLinkListeners } from './utils/links';
import { setupThemeDefaults } from './utils/theme_defaults';
import { setupThemeRefresh } from './utils/theme_refresh';

export function start() {
  setupLinkListeners();
  setupThemeDefaults();
  setupThemeRefresh();
}
